import { render, staticRenderFns } from "./city-view-page.vue?vue&type=template&id=fd8b8bb8&scoped=true&"
import script from "./city-view-page.vue?vue&type=script&lang=js&"
export * from "./city-view-page.vue?vue&type=script&lang=js&"
import style0 from "./city-view-page.vue?vue&type=style&index=0&id=fd8b8bb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd8b8bb8",
  null
  
)

export default component.exports
import {QBreadcrumbs,QIcon,QBreadcrumbsEl,QSeparator} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QBreadcrumbs,QIcon,QBreadcrumbsEl,QSeparator})
